var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{attrs:{"type":"dark","variant":"info"}},[_c('b-navbar-nav',[_c('b-navbar-brand',{staticClass:"name",attrs:{"to":"/"}},[_vm._v("Simple File Manager")])],1),_c('b-navbar-nav',{staticClass:"ml-auto"},[(_vm.signedIn)?_c('amplify-sign-out',{staticClass:"signout"}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }